import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { useIntl } from "react-intl"

const LocalizationProviderDatePicker = ({ locale, children }) => {
  const intl = useIntl()
  return (
    <LocalizationProvider
      adapterLocale={locale}
      dateAdapter={AdapterMoment}
      localeText={{
        cancelButtonLabel: intl.formatMessage({ id: "action.cancel" }),
        okButtonLabel: intl.formatMessage({ id: "action.ok" }),
        clearButtonLabel: intl.formatMessage({ id: "action.clear" }),
      }}
    >
      {children}
    </LocalizationProvider>
  )
}

export default LocalizationProviderDatePicker
